import { useQuery } from '@tanstack/react-query';
import { SEARCH_SUGGESTIONS } from 'constants/endpoints.api';
import { REQUEST_ID_HEADER } from 'constants/headers';
import { getRequestId } from 'utils/requestId';
import { getRelativeURLWithParams } from 'utils/url';
import { SearchSuggestionResponse } from './types';

export const useSearchSuggestionQuery = ({
  searchTerm,
  langId,
  storeIdentifier,
  storeId,
  catalogId,
  locale,
  serialNumber,
  esite
}) =>
  useQuery<SearchSuggestionResponse>({
    // TODO: dependencies missing in queryKey:serialNumber
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      'suggestions',
      searchTerm,
      langId,
      storeIdentifier,
      storeId,
      catalogId,
      locale
    ],
    queryFn: async () => {
      const url = getRelativeURLWithParams(SEARCH_SUGGESTIONS, {
        q: searchTerm.toLowerCase(),
        langId,
        storeIdentifier,
        storeId,
        catalogId,
        locale,
        serialNumber,
        esite
      });

      const res = await fetch(url, {
        headers: { [REQUEST_ID_HEADER]: getRequestId() }
      });

      return res.json();
    },

    // Query config
    enabled: searchTerm.length >= 3,
    placeholderData: (previousData) =>
      searchTerm.length >= 3 ? previousData : undefined
  });
